import React from 'react';
import Icon from '@common/assets';
import UpdateButton from '@components/profile/profileOverlay/overlays/common/updateBtn';
import AddButton from '@components/profile/profileOverlay/overlays/common/addBtn';
import { CareerStateType } from '@components/profile/profileOverlay/overlays/career/index';
import ProfileCareersVO, { CareersVO } from '@domain/vo/profile/ProfileCareersVO';
import Colors from '@domain/constant/colors';
import classnames from 'classnames/bind';
import styles from './career.module.scss';

const cx = classnames.bind(styles);

interface CareerListProps {
  profileCareer?: ProfileCareersVO | undefined;
  setCareerState: (careerState: CareerStateType) => void;
  setCareer: (career: CareersVO | null) => void;
  setCareerIndex: (careerIndex: number | null) => void;
  onClose: () => void;
  openNHISModal: () => void;
}

const CareerList = ({
  profileCareer,
  setCareer,
  setCareerIndex,
  setCareerState,
  onClose,
  openNHISModal,
}: CareerListProps) => {
  const isExist = !!profileCareer?.careers?.length;

  const handleExit = () => onClose();
  const writeNewEdu = () => {
    setCareer(null);
    setCareerIndex(null);
    setCareerState('FORM');
  };

  const listEls = profileCareer?.careers?.map((career, index) => {
    const { companyName, jobGroupName, jobTitleName, verified } = career;
    const handleClick = () => {
      setCareer(career);
      setCareerIndex(index);
      setCareerState('FORM');
    };

    const getDesc = () => {
      if (!jobGroupName && !jobTitleName) return '직군 · 직무를 입력해주세요.';
      if (!jobTitleName) return '직무를 입력해주세요.';
      return `${jobGroupName} > ${jobTitleName}`;
    };

    return (
      <li key={index} className={cx('listItem')}>
        <a className={cx('btnList')} role="button" onClick={handleClick}>
          <div className={cx('contentsArea')}>
            <div className={cx('listTextArea')}>
              <span className={cx('listText')}>{companyName}</span>
              {verified && <Icon name={'verifiedLightFilled'} width={24} height={24} fill={Colors.C_GREEN_150} />}
            </div>

            <span className={cx('listDesc')}>{getDesc()}</span>
          </div>
          <Icon name="arrowRightLight" width={40} height={40} />
        </a>
      </li>
    );
  });

  const getContentsEl = () => {
    if (isExist) {
      return (
        <>
          <div className={cx('addBtnArea')}>
            <AddButton
              theme={'light'}
              beforeIcon={<Icon name={'addLight'} fill={Colors.C_BLACK} width={24} height={24} />}
              text={'직접 추가하기'}
              onClick={writeNewEdu}
            />
            <AddButton
              theme={'dark'}
              beforeIcon={<Icon name={'verifiedLightFilled'} fill={Colors.C_GREEN_150} width={24} height={24} />}
              text={'경력 불러오기'}
              onClick={openNHISModal}
            />
          </div>

          <ul className={cx('list')}>{listEls}</ul>

          <div className={cx('updateBtnArea')}>
            <UpdateButton onClick={() => setCareerState('DELETE')} disabled={!isExist} />
          </div>
        </>
      );
    }

    return (
      <div className={cx('largeBtnArea')}>
        <AddButton
          type={'large'}
          beforeIcon={<Icon name={'addLight'} fill={Colors.C_BLACK} width={32} height={32} />}
          afterIcon={<Icon name={'arrowRightLight'} fill={Colors.C_BLACK} width={40} height={40} />}
          text={'직접 추가하기'}
          onClick={writeNewEdu}
        />
        <AddButton
          theme={'dark'}
          type={'large'}
          beforeIcon={<Icon name={'verifiedLightFilled'} fill={Colors.C_GREEN_150} width={32} height={32} />}
          afterIcon={<Icon name={'arrowRightLight'} fill={Colors.C_WHITE} width={40} height={40} />}
          text={'경력 불러오기'}
          onClick={openNHISModal}
        />
      </div>
    );
  };

  return (
    <>
      <div className={cx('scrollArea')}>
        <div className={cx('scrollInner')}>
          <div className={cx('scrollWrap')}>
            <div className={cx('listArea')}>{getContentsEl()}</div>
          </div>
        </div>
      </div>

      <div className={cx('btnArea')}>
        <a className={cx('btn', 'cancel')} role="button" onClick={handleExit}>
          나가기
        </a>
      </div>
    </>
  );
};

export default CareerList;
